import React from 'react'
import Toggle from 'components/toggle'

interface SwitchFieldProps {
  title: string
  /** What turning it on does, in a sentence. */
  description?: React.ReactNode
  checked: boolean
  onChange: (checked: boolean) => void
  disabled?: boolean
  /** In a bordered box of its own instead of under a hairline: a setting that belongs to what's above it. */
  boxed?: boolean
  className?: string
}

/**
 * A setting in the manner of shadcn/ui's switch field: its name and a line saying what it does, the switch at the
 * top right, under a hairline that sets it apart from the setting above. A press anywhere on it flips it.
 */
const SwitchField: React.FC<SwitchFieldProps> = ({
  title,
  description,
  checked,
  onChange,
  disabled,
  boxed = false,
  className
}) => (
  <div
    className={`flex items-start gap-3 ${boxed ? 'rounded-lg border border-divider p-3' : 'border-t border-divider pt-4'} ${disabled ? 'opacity-60' : 'cursor-pointer'} ${className ?? ''}`}
    onClick={(event) => {
      // The switch flips itself; this is for the rest of the field.
      if (disabled || (event.target as HTMLElement).closest('[role="switch"]')) return
      onChange(!checked)
    }}
  >
    <div className="flex min-w-0 flex-1 flex-col gap-1 select-none">
      <span className="text-[13px] leading-5 font-medium text-body">{title}</span>
      {description && <span className="text-[13px] leading-5 whitespace-normal text-muted">{description}</span>}
    </div>
    <div className="flex h-5 items-center">
      <Toggle aria-label={title} toggled={checked} onToggle={onChange} disabled={disabled} />
    </div>
  </div>
)

export default SwitchField
